import { Grid, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, TableFooter } from "@material-ui/core";
import React, { useEffect } from "react";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import LoadingOverlay from 'react-loading-overlay';
import ReactLoading from 'react-loading';
import { CallAPI } from "services/API";

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

export const Comparison_GWPPPTC = (props) => {
    const isMobile = useMediaQuery('(max-width: 1152px)');
    const cellStyle = { fontSize: "1.6em", lineHeight: "1.3em", color: "#ff8000", textAlign: "left", textWrap: "nowrap" };
    const headerStyle = { fontSize: "1.3em", color: "#1d4c80", fontWeight: "400", textWrap: "nowrap" }
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    const [data, setData] = React.useState([]);
    const [total, setTotal] = React.useState({ transactionCode: 'Total Premium' });
    const [loading, setLoading] = React.useState(false);

    const GetData = async (type) => {
        const response = await CallAPI("POST", "/Comparison/GetGrossWrittenPremium", {
            startDateA: props.startDateA,
            endDateA: props.endDateA,
            startDateB: props.startDateB,
            endDateB: props.endDateB,
            states: props.states,
            city: props.city
        });

        if (response) {
            setData(response.filter(x => x.transactionCode !== 'Total Premium'));
            setTotal(response.find(x => x.transactionCode === 'Total Premium'));
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call == "true" || props.call == null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);

    return (
        <div
            style={
                isMobile ?
                    {
                        marginTop: "2em",
                        marginLeft: "0em",
                        marginRight: "0em",
                        backgroundColor: "#f1f1f1"
                    }
                    :
                    {
                        marginTop: "2em",
                        marginLeft: ".5em",
                        marginRight: ".5em",
                        backgroundColor: "#f1f1f1"
                    }
                
            }
        >
            <LoadingOverlay
                active={loading}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        position: "absolute!important"
                    })
                }}
                spinner={<ReactLoading type={'spin'} height={50} width={50} />}
            >
            <Grid container>
                <Grid item
                    xs={12} sm={12} md={12} lg={3}
                    style={{ textAlign: "center" }}
                >
                    <span
                        style={
                            isMobile ?
                                {
                                    fontSize: "1.8em",
                                    color: "#1d4c80",
                                    paddingTop: "1.2em",
                                    paddingBottom: "1em",
                                    paddingLeft: ".4em",
                                    display: "inline-block"
                                }
                                :
                                {
                                    fontSize: "1.6em",
                                    color: "#1d4c80",
                                    paddingTop: "1.2em",
                                    paddingBottom: "1em",
                                    paddingLeft: "1em",
                                    display: "inline-block"
                                }
                        }
                    >
                        GROSS WRITTEN PREMIUM
                    </span>
                </Grid>
                <Grid item
                    xs={12} sm={12} md={12} lg={9}
                    style={ useMediaQuery('(max-width: 1025px)') ?{ textAlign: "center" } : { textAlign: "left" }}
                    >
                </Grid>
                <Grid item xs={12}>
                    <TableContainer  style={{ position: "relative", marginTop: "1em", margin:"auto", maxWidth:"1200px" }}>
                        <Table sx={{ width: "1200px" }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={headerStyle}>TRANSACTION CODE</TableCell>
                                        <TableCell style={headerStyle}>RANGE A</TableCell>
                                        <TableCell style={headerStyle}>RANGE A AGENCY</TableCell>
                                        <TableCell style={headerStyle}>RANGE B</TableCell>
                                        <TableCell style={headerStyle}>RANGE B AGENCY</TableCell>
                                        <TableCell style={headerStyle}>CHANGE</TableCell>
                                        <TableCell style={headerStyle}>CHANGE AGENCY</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody >
                                {data.map((row) => (
                                    <TableRow key={row.transactionCode} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row" style={headerStyle}>{row.transactionCode}</TableCell>
                                        <TableCell style={cellStyle}>{currency.format(row.rangeAPremium)}</TableCell>
                                        <TableCell style={cellStyle}>
                                            {currency.format(row.rangeAAgency)} ({percent.format(Math.abs(row.rangeAAgencyPercentage) / 100)})
                                        </TableCell>
                                        <TableCell style={cellStyle}>{currency.format(row.rangeBPremium)}</TableCell>
                                        <TableCell style={cellStyle}>
                                            {currency.format(row.rangeBAgency)} ({percent.format(Math.abs(row.rangeBAgencyPercentage) / 100)})
                                        </TableCell>
                                        <TableCell style={row.change > 0 ? { fontSize: "1.6em", lineHeight: "1.3em", color: "green" } : { fontSize: "1.6em", lineHeight: "1.3em", color: "red" }}>
                                            {row.change > 0 && <ArrowUpward style={{ marginBottom: "-7px" }} />}
                                            {row.change < 0 && <ArrowDownward style={{ marginBottom: "-7px" }} />}
                                            {percent.format(row.change / 100)}
                                        </TableCell>
                                        <TableCell style={row.agencyChange > 0 ? { fontSize: "1.6em", lineHeight: "1.3em", color: "green" } : { fontSize: "1.6em", lineHeight: "1.3em", color: "red" }}>
                                            {row.agencyChange > 0 && <ArrowUpward style={{ marginBottom: "-7px" }} />}
                                            {row.agencyChange < 0 && <ArrowDownward style={{ marginBottom: "-7px" }} />}
                                            {percent.format(row.agencyChange / 100)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableFooter>
                                <TableRow key={total.transactionCode} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="total" style={headerStyle}>{total.transactionCode}</TableCell>
                                    <TableCell style={cellStyle}>{currency.format(total.rangeAPremium ?? 0)}</TableCell>
                                    <TableCell style={cellStyle}>
                                        {currency.format(total.rangeAAgency ?? 0)} ({percent.format(Math.abs(total.rangeAAgencyPercentage ?? 0) / 100)})
                                    </TableCell>
                                    <TableCell style={cellStyle}>{currency.format(total.rangeBPremium ?? 0)}</TableCell>
                                    <TableCell style={cellStyle}>
                                        {currency.format(total.rangeBAgency ?? 0)} ({percent.format(Math.abs(total.rangeBAgencyPercentage ?? 0) / 100)})
                                    </TableCell>
                                    <TableCell style={total.change > 0 ? { fontSize: "1.6em", lineHeight: "1.3em", color: "green" } : { fontSize: "1.6em", lineHeight: "1.3em", color: "red" }}>
                                        {total.change > 0 && <ArrowUpward style={{ marginBottom: "-7px" }} />}
                                        {total.change < 0 && <ArrowDownward style={{ marginBottom: "-7px" }} />}
                                        {percent.format((total.change ?? 0) / 100)}
                                    </TableCell>
                                    <TableCell style={total.agencyChange > 0 ? { fontSize: "1.6em", lineHeight: "1.3em", color: "green" } : { fontSize: "1.6em", lineHeight: "1.3em", color: "red" }}>
                                        {total.agencyChange > 0 && <ArrowUpward style={{ marginBottom: "-7px" }} />}
                                        {total.agencyChange < 0 && <ArrowDownward style={{ marginBottom: "-7px" }} />}
                                        {percent.format((total.agencyChange ?? 0) / 100)}
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
            </LoadingOverlay>

        </div>
    );
}
